import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination, EffectFade } from 'swiper/modules';
import { useScreenSize, SCREEN_SIZES } from 'react-hooks/useScreenSize';
// Icons
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';


const AnnouncementBar = ({ announcementMessages }) => {
  const containerRef = useRef(null);
  const swiperRef = useRef(null);
  const pauseTimeoutRef = useRef(null);

  const { screenSize } = useScreenSize();
  const isDesktop = screenSize === SCREEN_SIZES.DESKTOP;

  const pauseAutoplay = () => {
    if (!swiperRef.current) return;

    swiperRef.current.autoplay.stop();

    swiperRef.current.navigation.update();

    clearTimeout(pauseTimeoutRef.current);

    pauseTimeoutRef.current = setTimeout(() => {
      swiperRef.current?.autoplay?.start();
      swiperRef.current?.navigation?.update();
    }, 10000);
  };

  return (
    <div className='tw-group tw-pt-10 tw-pb-6 tw-gap-6 tw-bg-[#005EB8]' 
      onMouseEnter={pauseAutoplay}
      onClick={pauseAutoplay}
    >
      <div className='tw-relative tw-max-w-[600px] tw-mx-auto tw-pt-2'>
        {isDesktop && announcementMessages.length > 1 && (
           <div className="tw-cursor-pointer tw-bg-[#005EB8] tw-absolute tw-left-0 tw-text-white tw-top-1/2 tw--translate-y-1/2 tw-z-[2] group-hover:tw-opacity-100 tw-opacity-0 tw-transition-opacity" data-announcement-prev>
            <ChevronLeftIcon className="tw-size-20" />
          </div>
        )}

      <Swiper
          className="tw-flex" 
          speed={700}
          spaceBetween={0}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;

            swiper.params.navigation.prevEl = '[data-announcement-prev]';
            swiper.params.navigation.nextEl = '[data-announcement-next]';
          
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          modules={[Autoplay, Pagination, EffectFade, Navigation]}
          pagination={{
              el: '[data-announcement-pagination]',
              clickable: true,
              renderBullet: (index, className) =>
                `<span key='${index}' class="${className} tw-block tw-size-4 tw-rounded-full tw-bg-white tw-mx-1 tw-transition-opacity"></span>`
          }}
        >
          {announcementMessages.map((message, index) => (
            <SwiperSlide 
              key={index}
              className="tw-relative tw-z-[4]  tw-flex tw-h-16 tw-items-center tw-justify-center [&_a]:tw-underline hover:[&_a]:tw-text-[#6c7271]
              tw-py-[4px] tw-text-12 desktop:tw-text-14 tw-font-semibold tw-leading-14 desktop:tw-leading-[16px] tw-text-white"
              dangerouslySetInnerHTML={{ __html: message }}
            />
          ))}
        </Swiper>  
        
        {isDesktop && announcementMessages.length > 1 && (
          <div className="tw-cursor-pointer tw-bg-[#005EB8] tw-absolute tw-right-0 tw-text-white tw-top-1/2 tw--translate-y-1/2 tw-z-[2] group-hover:tw-opacity-100 tw-opacity-0 tw-transition-opacity" data-announcement-next>
            <ChevronRightIcon className="tw-size-20" />
          </div>
        )}

        <div data-announcement-pagination className="tw-flex tw-pointer-events-none tw-mt-6 tw-z-10 !tw-w-fit tw-mx-auto tw-touch-none tw-items-center tw-justify-center tw-px-4" />
      </div>
    </div>
  );
};

export default AnnouncementBar;


